module.exports = __webpack_public_path__ + "img/Home.0f3e7250.svg";